export const MODAL_KEYS = {
	UPDATE_SYSTEM: 'update-system'
}
